// import "@/assets/less/chat/main.less"

export default async () => {
  if (!window.kendo.ui.ChitChat) {
    await import("@rosgidromet/visary-chat-rgm");
  }
}
